/** String type handler. Excepts any value. */ export const string = ({ value })=>{
  return value;
};
//# sourceMappingURL=string.js.map